import React from "react";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBIcon,
  MDBBadge,
} from "mdb-react-ui-kit";

/**
 * Modal de sugerencia de categorías similares.
 *
 * Props:
 *   suggestions       – [{ IDCategoria, Nombre, score, motivo }]
 *   nombrePropuesto   – string: nombre que el usuario quería usar
 *   onUseExisting     – (IDCategoria, Nombre) => void: usar una categoría existente
 *   onCreateAnyway    – () => void: ignorar sugerencias y proceder igualmente
 *   onCancel          – () => void: cerrar sin hacer nada
 */
export class CategoriaSuggestionModal extends React.Component {
  getMotivoLabel(motivo) {
    switch (motivo) {
      case "EXACT_NORMALIZED": return { text: "Nombre idéntico", color: "danger" };
      case "LEVENSHTEIN_1":    return { text: "Muy similar", color: "warning" };
      case "PLURAL_SINGULAR":  return { text: "Singular/plural", color: "info" };
      case "LEVENSHTEIN_2":    return { text: "Similar", color: "secondary" };
      default:                 return { text: "Similar", color: "secondary" };
    }
  }

  render() {
    const { suggestions, nombrePropuesto, onUseExisting, onCreateAnyway, onCancel } = this.props;

    return (
      <MDBModal show={true} onHide={onCancel} tabIndex="-1">
        <MDBModalDialog size="md" centered>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>
                <MDBIcon fas icon="exclamation-triangle" className="me-2 text-warning" />
                Categoría similar encontrada
              </MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={onCancel} />
            </MDBModalHeader>

            <MDBModalBody>
              <p className="mb-3">
                El nombre <strong>"{nombrePropuesto}"</strong> es similar a{" "}
                {suggestions.length === 1 ? "esta categoría ya existente" : "estas categorías ya existentes"}:
              </p>
              <ul className="list-unstyled mb-0">
                {suggestions.map((s) => {
                  const motivo = this.getMotivoLabel(s.motivo);
                  return (
                    <li
                      key={s.IDCategoria}
                      className="d-flex align-items-center justify-content-between mb-2 p-2 rounded border"
                    >
                      <div className="d-flex align-items-center gap-2 flex-wrap">
                        <strong>{s.Nombre}</strong>
                        <MDBBadge color={motivo.color} light pill>
                          {motivo.text}
                        </MDBBadge>
                      </div>
                      <MDBBtn size="sm" color="primary" onClick={() => onUseExisting(s.IDCategoria, s.Nombre)}>
                        Usar esta
                      </MDBBtn>
                    </li>
                  );
                })}
              </ul>
            </MDBModalBody>

            <MDBModalFooter className="justify-content-between">
              <MDBBtn color="light" size="sm" onClick={onCancel}>
                Cancelar
              </MDBBtn>
              <MDBBtn color="secondary" size="sm" onClick={onCreateAnyway}>
                <MDBIcon fas icon="plus" className="me-1" />
                Crear de todas formas
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    );
  }
}
